import * as yup from "yup";

const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Minimum 3 characters")
    .required("Name is required"),

  parent_id:yup
    .string()
    .when("isLevel0", {
      is: false,
      then: yup.string()
                .typeError("Parent id is required")
                .required("Parent id is required"),
      otherwise: yup.string().nullable(),
    }),

  manager: yup
    .array()
    .of(yup.string())
    .nullable(true),

  agent: yup
    .array()
    .of(yup.string())
    .nullable(true),

  add: yup
    .array()
    .of(yup.string())
    .nullable(true),

  remove: yup
    .array()
    .of(yup.string())
    .nullable(true),

    isLevel0: yup.boolean(),
});

export default schema;
